import React from 'react';
import classNames from 'classnames';
import PageLink from './page_link.jsx';
import NavButton from './nav_button.jsx';

/* eslint no-mixed-operators: 0 */

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.handleNext = this.handleNext.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.previousButtonHref = this.previousButtonHref.bind(this);
    this.nextButtonHref = this.nextButtonHref.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { scrollTopOnChange, selected } = this.props;
    if (scrollTopOnChange && selected !== prevProps.selected) {
      $(window).scrollTop(0);
    }
  }

  renderPageLink(index) {
    return (
      <PageLink
        selected={this.props.selected === index}
        pageNumber={index}
        onClick={
          this.props.links ? undefined : () => this.handleSelected(index)
        }
        key={index}
        link={this.props.links ? this.props.links[index] : undefined}
        className={this.props.hidePagesOnMobile ? 'u-hideBelowSM' : ''}
      />
    );
  }

  renderPageBreak(key) {
    const { hidePagesOnMobile } = this.props;
    const className = `Pagination-pageBreak ${
      hidePagesOnMobile ? 'u-hideBelowSM' : ''
    }`;
    return <li key={key} className={className} children="..." />;
  }

  renderPages() {
    const { margins, range, pages, selected } = this.props;

    const pageLinks = [];
    if (pages <= range) {
      for (let page = 1; page <= pages; page += 1)
        pageLinks.push(this.renderPageLink(page));
    } else {
      let shouldBreak;
      let leftSide = range / 2;
      let rightSide = range - leftSide;

      if (selected > pages - range / 2) {
        rightSide = pages - selected;
        leftSide = range - rightSide;
      } else if (selected < range / 2) {
        leftSide = selected;
        rightSide = range - leftSide;
      }

      for (let page = 1; page <= pages; page += 1) {
        if (page <= margins) {
          pageLinks.push(this.renderPageLink(page));
          shouldBreak = true;
        } else if (page > pages - margins) {
          pageLinks.push(this.renderPageLink(page));
        } else if (
          page >= selected - leftSide &&
          page <= selected + rightSide
        ) {
          pageLinks.push(this.renderPageLink(page));
          shouldBreak = true;
        } else if (shouldBreak) {
          pageLinks.push(this.renderPageBreak(page));
          shouldBreak = false;
        }
      }
    }

    return pageLinks;
  }

  handleSelected(page) {
    const { pageSelectCallback, selected } = this.props;
    if (selected !== page) {
      pageSelectCallback(page);
    }
  }

  handleNext() {
    if (this.props.selected >= this.props.pages || this.props.links) return;
    this.handleSelected(this.props.selected + 1);
  }

  handlePrev() {
    if (this.props.selected <= 1 || this.props.links) return;
    this.handleSelected(this.props.selected - 1);
  }

  previousButtonHref(isPreviousDisabled) {
    const { links, selected } = this.props;

    if (links && !isPreviousDisabled) {
      return links[selected - 1];
    }
    return undefined;
  }

  nextButtonHref(isNextDisabled) {
    const { links, selected } = this.props;

    if (links && !isNextDisabled) {
      return links[selected + 1];
    }
    return undefined;
  }

  render() {
    const {
      pages,
      selected,
      className,
      /** @deprecated use className instead */
      customClass,
    } = this.props;

    const isPreviousDisabled = selected <= 1;
    const isNextDisabled = selected >= pages;
    const componentClassNames = classNames(
      'Pagination-list',
      className,
      customClass,
    );

    return (
      <ul
        className={componentClassNames}
        aria-label={t('pagination.controls_group')}
      >
        <NavButton
          href={this.previousButtonHref(isPreviousDisabled)}
          onClick={this.handlePrev}
          disabled={isPreviousDisabled}
          ariaLabel={t('pagination.previous_page')}
        >
          {t('pagination.prev')}
        </NavButton>
        {this.renderPages()}
        <NavButton
          href={this.nextButtonHref(isNextDisabled)}
          onClick={this.handleNext}
          disabled={isNextDisabled}
          ariaLabel={t('pagination.next_page')}
        >
          {t('pagination.next')}
        </NavButton>
      </ul>
    );
  }
}

Pagination.defaultProps = {
  margins: 1,
  range: 6,
  selected: 1,
  hidePagesOnMobile: true,
  scrollTopOnChange: false,
};

export default Pagination;
